(function () {
  const MARKER_KEY = 'cv_store_mode_active';
  const STARTED_AT_KEY = 'cv_store_mode_started_at';
  const STORE_MODE_VALUE = 'nagoya';
  const STORE_MODE_ATTRIBUTE = '__cv_store_mode';
  const TTL_MS = 12 * 60 * 60 * 1000;

  const getSessionStorage = () => {
    try {
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  };

  const updateStoreModeAttribute = (value) => {
    const cartUpdateUrl = window.routes?.cart_update_url || '/cart/update.js';
    return fetch(cartUpdateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: { [STORE_MODE_ATTRIBUTE]: value } }),
    });
  };

  const readStartedAt = (storage) => {
    const startedAt = Number(storage?.getItem(STARTED_AT_KEY) || 0);
    return Number.isFinite(startedAt) ? startedAt : 0;
  };

  const hasActiveMarker = (storage) => {
    if (!storage || storage.getItem(MARKER_KEY) !== STORE_MODE_VALUE) return false;

    const startedAt = readStartedAt(storage);
    return startedAt > 0 && Date.now() - startedAt <= TTL_MS;
  };

  const setMarker = (storage) => {
    storage?.setItem(MARKER_KEY, STORE_MODE_VALUE);
    storage?.setItem(STARTED_AT_KEY, String(Date.now()));
  };

  const clearMarker = (storage) => {
    storage?.removeItem(MARKER_KEY);
    storage?.removeItem(STARTED_AT_KEY);
  };

  const syncStoreMode = () => {
    const storage = getSessionStorage();
    const isStoreModePage = Boolean(document.querySelector('[data-cv-store-mode]'));
    const params = new URLSearchParams(window.location.search);
    const qrId = params.get('cv_qr_id') || '';
    const hasStoreQr = params.get('utm_medium') === 'qr' && /^NGY-[A-Z0-9-]+$/.test(qrId);

    if (isStoreModePage && hasStoreQr) {
      setMarker(storage);
      updateStoreModeAttribute(STORE_MODE_VALUE).catch((error) => {
        console.error('CV Store Mode flag save failed', error);
      });
      return;
    }

    if (hasActiveMarker(storage)) return;

    clearMarker(storage);
    updateStoreModeAttribute('').catch((error) => {
      console.error('CV Store Mode flag clear failed', error);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncStoreMode, { once: true });
  } else {
    syncStoreMode();
  }
})();
